/* MR14 · Avis (préfixe av-) : petit confort d'affichage, aucun script Judge.me.
   - Au-delà de 6 avis, les suivants sont repliés derrière « Voir les N autres avis » (sans JavaScript : tout est visible).
   - Les photos s'ouvrent en grand dans une fenêtre (<dialog>) ; sans JavaScript, le lien ouvre l'image. */
(function () {
  'use strict';
  const PREMIERS = 6;

  function monter(sec) {
    const items = [...sec.querySelectorAll('[data-av-item]')];
    const boite = sec.querySelector('[data-av-plus-boite]');
    const btn = sec.querySelector('[data-av-plus]');
    if (boite && btn && items.length > PREMIERS) {
      items.slice(PREMIERS).forEach((li) => { li.hidden = true; });
      boite.hidden = false;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', () => {
        const suivant = items[PREMIERS];
        items.slice(PREMIERS).forEach((li, i) => {
          li.hidden = false;
          li.style.setProperty('--av-d', Math.min(i, 8) * 50 + 'ms');
          li.classList.add('av-apparait');
        });
        boite.hidden = true;
        btn.setAttribute('aria-expanded', 'true');
        const lien = suivant && suivant.querySelector('a, button');
        if (suivant) { suivant.setAttribute('tabindex', '-1'); suivant.focus({ preventScroll: true }); }
        if (lien) lien.blur();
      });
    }

    // Photos en grand
    const dlg = document.createElement('dialog');
    dlg.className = 'av-dlg';
    dlg.setAttribute('aria-label', 'Photo de l’acheteur');
    dlg.innerHTML = '<img alt=""><button type="button" class="av-dlg-fermer" aria-label="Fermer la photo"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg></button>';
    if (typeof dlg.showModal !== 'function') return;
    document.body.appendChild(dlg);
    const img = dlg.querySelector('img');
    dlg.querySelector('button').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    sec.addEventListener('click', (e) => {
      const a = e.target.closest('[data-av-photo]');
      if (!a) return;
      e.preventDefault();
      img.src = a.href;
      img.alt = (a.querySelector('img') || {}).alt || '';
      dlg.showModal();
    });
  }

  function demarrer() { document.querySelectorAll('[data-av]').forEach(monter); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
